import { useUniquePrefix } from '@components/hooks';
import { FC, useState, createContext, useMemo, useEffect } from 'react';
import { TabContextProps, TabContextValue } from './TabContext.types';

export const TabContext = createContext<TabContextValue | undefined>(undefined);

const TabContextProvider: FC<TabContextProps> = (props: TabContextProps) => {
  const { children, value } = props;
  const [activeTab, setActiveTab] = useState(value);

  const idPrefix = useUniquePrefix();

  const context = useMemo(() => {
    return { idPrefix, activeTab, setActiveTab };
  }, [idPrefix, activeTab]);

  useEffect(() => {
    setActiveTab(value);
  }, [value]);

  return <TabContext.Provider value={context}>{children}</TabContext.Provider>;
};

export default TabContextProvider;
